import {
  Card,
  Typography,
  Input,
  Button,
  Pagination,
  Empty,
  Tooltip,
  Switch,
  Tag,
} from "antd";
import { DeleteOutlined, PlusOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import { useState, useEffect } from "react";
import SortingArrow from "../../Common/SortingArrow";
import { useDispatch } from "react-redux";
import globalRequest from "../../utils/global/globalRequest";
import * as Validation from "../../utils/helper/validation";
import * as Apis from "../../utils/helper/enum";
import toast from "react-hot-toast";
import { paginationLimit, paginationPages } from "../../utils/helper/constants";
import {
  addDeleteGetLocalStorage,
  storageKeys,
} from "../../utils/global/localData";
import { jwtDecode } from "jwt-decode";
import { changeLoader } from "../../redux/reducers/loader";
import { capitalizeName, formatDateFunction } from "../../utils/helper/utils";
import { checkPermissionAction } from "../../utils/helper/utils";

let timer = null;

const ManageCannedCoupon = () => {
  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [inputData, setInputData] = useState({});
  const [totalRows, setTotalRows] = useState(0);
  const [itemData, setItemData] = useState(null);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const { Search } = Input;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const userAccess = addDeleteGetLocalStorage(
    storageKeys?.USER_TOKEN,
    {},
    "get"
  );
  let permissionJson = [];
  if (userAccess) {
    const decoded = jwtDecode(userAccess);
    permissionJson = decoded?.user?.rolePermission?.permissionJson;
  }

  const handleDeleteOk = async () => {
    setIsDeleteModalOpen(false);
    try {
      let value = { status: "deleted" };
      let response = await globalRequest(
        Apis?.MANAGE_CANNED_COUPON?.UPDATE_STATUS + "/" + itemData.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Canned Coupon deleted successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllCannedCoupon();
      } else {
        toast.error(apiResponse?.message || "Failed to delete canned coupon");
      }
    } catch (e) {
      toast.error(e?.message || "Something went wrong");
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      order_by: column,
      order_type: order,
    }));
  };

  const getAllCannedCoupon = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_CANNED_COUPON.GET_ALL_COUPON,
        "get",
        {},
        { params: params },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setList(apiResponse?.data?.data || apiResponse?.data?.rows || apiResponse?.data || []);
        setTotalRows(apiResponse?.data?.paginator?.itemCount || apiResponse?.data?.total || 0);
      } else {
        // Handle unexpected status
      }
    } catch (e) {
      toast.error(e?.message || "Failed to fetch canned coupons");
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      getAllCannedCoupon();
    }, 400);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleStatusChange = async (item) => {
    try {
      let value = { status: item.status === "active" ? "inactive" : "active" };
      let response = await globalRequest(
        Apis?.MANAGE_CANNED_COUPON?.UPDATE_STATUS + "/" + item.id,
        "put",
        value,
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = item.status === "active" ? "Coupon inactive successfully" : "Coupon active successfully";
        toast.success(msg, {
          duration: 2000,
        });
        getAllCannedCoupon();
      } else {
        toast.error(apiResponse?.message || "Failed to update status");
      }
    } catch (e) {
      toast.error(e?.message || "Something went wrong");
    }
  };

  return (
    <>
      <Card>
        <div className="block sm:flex justify-between mb-4 gap-5">
          <div>
            <Typography className="text-xl font-semibold" align={"left"}>
              Canned Coupon Management
            </Typography>
          </div>
          <div>
            <Search
              placeholder="Search by code or mobile"
              style={{
                width: 250,
              }}
              className="mx-1.5 cursor-pointer my-3 sm:my-0"
              onChange={(e) => {
                let value = Validation.strFormat(e.target.value, "trim");
                setInputData((prev) => ({ ...prev, search: value }));
                setPaginationModel((prev) => ({ ...prev, page: 1 }));
              }}
            />
            {checkPermissionAction("Manage Canned Coupon", permissionJson, "add") ? (
              <Button
                type="primary"
                size={14}
                icon={<PlusOutlined />}
                className="cursor-pointer"
                onClick={() => navigate("/manage-canned-coupon/create-coupon")}
              >
                New Coupon
              </Button>
            ) : null}
          </div>
        </div>

        <div className="relative overflow-x-auto">
          <table className="w-full text-left text-sm text-gray-500">
            <thead className="text-gray-700 capitalize text-xs bg-gray-50">
              <tr>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  ID{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("id", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Discount For{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("discountFor", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Coupon Code / Mobile{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("couponCode", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Discount Type{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("discountType", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Discount Amount{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("couponAmount", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Valid To{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("couponExpiryDate", order)}
                  />
                </th>
                <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {list?.length ? (
                list?.map((item, index) => (
                  <tr className="bg-white border-b" key={index}>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.id || "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.discountFor === "mobile_number" ? (
                        <Tag color="cyan">Mobile Number</Tag>
                      ) : (
                        <Tag color="blue">Coupon Code</Tag>
                      )}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap font-medium text-gray-900">
                      {item?.couponCode || "-"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.discountType === "flat_cap"
                        ? "Flat Cap"
                        : capitalizeName(item?.discountType)}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.couponAmount}{" "}
                      {item?.discountType === "percentage" ? "%" : "SAR"}
                    </td>
                    <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.couponExpiryDate
                        ? formatDateFunction(item?.couponExpiryDate, "dd-mm-yyyy")
                        : "-"}
                    </td>
                    <td className="px-3 py-4 text-left whitespace-nowrap vertical-top">
                      <Tooltip title="Edit permission">
                        <EditOutlined
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Manage Canned Coupon",
                                permissionJson,
                                "edit"
                              )
                            ) {
                              navigate("/manage-canned-coupon/edit-coupon/" + item.id);
                            }
                          }}
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Manage Canned Coupon",
                              permissionJson,
                              "edit"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                        />
                      </Tooltip>
                      <Tooltip title="Delete">
                        <DeleteOutlined
                          className={`mx-1.5 cursor-pointer ${
                            !checkPermissionAction(
                              "Manage Canned Coupon",
                              permissionJson,
                              "delete"
                            )
                              ? "text-gray-400 cursor-not-allowed"
                              : ""
                          }`}
                          onClick={() => {
                            if (
                              checkPermissionAction(
                                "Manage Canned Coupon",
                                permissionJson,
                                "delete"
                              )
                            ) {
                              setIsDeleteModalOpen(true);
                              setItemData(item);
                            }
                          }}
                        />
                      </Tooltip>
                      <Switch
                        size="small"
                        checked={item?.status === "active"}
                        onChange={() => {
                          handleStatusChange(item);
                        }}
                        disabled={
                          !checkPermissionAction(
                            "Manage Canned Coupon",
                            permissionJson,
                            "update_status"
                          )
                        }
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={7} className="text-center mt-3 py-8">
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {list?.length ? (
          <div className="text-right mt-4">
            <Pagination
              defaultCurrent={1}
              total={totalRows}
              pageSizeOptions={paginationPages}
              showSizeChanger={true}
              current={paginationModel?.page}
              pageSize={paginationModel?.limit}
              onChange={(page) =>
                setPaginationModel((prev) => ({ ...prev, page: page }))
              }
              onShowSizeChange={(current, size) =>
                setPaginationModel((prev) => ({ ...prev, limit: size }))
              }
            />
          </div>
        ) : null}
      </Card>

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && (
        <ConfirmationModal
          ConfirmationHeading="Delete"
          ConfirmationParagraph="Are you sure you want to delete this Canned Coupon?"
          isOpen={isDeleteModalOpen}
          onOk={handleDeleteOk}
          onCancel={handleDeleteCancel}
        />
      )}
    </>
  );
};

export default ManageCannedCoupon;
